import { useEffect } from 'react'

type Params = {
  open: boolean
  onThemeChange: () => void
}

export const useImageZoomThemeObserver = ({ open, onThemeChange }: Params) => {
  useEffect(() => {
    if (!open || typeof window === 'undefined' || typeof document === 'undefined') return

    const root = document.documentElement
    const body = document.body
    const media = window.matchMedia('(prefers-color-scheme: dark)')

    const observer = new MutationObserver((mutations) => {
      if (
        mutations.some(
          (mutation) =>
            mutation.type === 'attributes' &&
            (mutation.attributeName === 'class' || mutation.attributeName === 'data-theme'),
        )
      ) {
        onThemeChange()
      }
    })

    observer.observe(root, { attributes: true, attributeFilter: ['class', 'data-theme'] })
    observer.observe(body, { attributes: true, attributeFilter: ['class', 'data-theme'] })
    media.addEventListener('change', onThemeChange)

    return () => {
      observer.disconnect()
      media.removeEventListener('change', onThemeChange)
    }
  }, [onThemeChange, open])
}
